import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { spacing16, spacing8 } from 'approot/shared/styles/spacing.style';
import { Heading16 } from 'approot/shared/styles/typography.style';
import { grey5 } from 'approot/shared/styles/colours.style';
import { baseFlexCss } from 'approot/shared/styles/flex.style';

export const ActivityViewDetails = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  height: 100%;
`;

export const ActivityViewDetailsTitle = styled(Heading16).attrs({
  as: 'h2',
})`
  ${baseFlexCss}
  flex-wrap: wrap;

  span {
    margin-right: ${rem(spacing8)};
  }
`;

export const ActivityViewDetailsContent = styled.div`
  border-top: 1px solid ${grey5};
  padding: ${rem(spacing16)};
  padding-bottom: 0;
`;
